import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Gestion du formulaire de contact
  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const messageDiv = document.getElementById('form-message');
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5rdiuk98t1oshnre7h0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (messageDiv) {
        if (response.ok) {
          messageDiv.className = 'text-center p-4 rounded-lg bg-green-100 text-green-700';
          messageDiv.textContent = '✓ Votre demande a été envoyée avec succès !';
          form.reset();
        } else {
          messageDiv.className = 'text-center p-4 rounded-lg bg-red-100 text-red-700';
          messageDiv.textContent = '✗ Une erreur est survenue. Veuillez réessayer.';
        }
        messageDiv.classList.remove('hidden');
        setTimeout(() => messageDiv.classList.add('hidden'), 5000);
      }
    } catch (error) {
      if (messageDiv) {
        messageDiv.className = 'text-center p-4 rounded-lg bg-red-100 text-red-700';
        messageDiv.textContent = '✗ Erreur de connexion. Veuillez réessayer.';
        messageDiv.classList.remove('hidden');
        setTimeout(() => messageDiv.classList.add('hidden'), 5000);
      }
    }
  };

  // Gestion du formulaire newsletter
  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5rdiuk98t1oshnre7hg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('✓ Inscription réussie !');
        form.reset();
      } else {
        alert('✗ Une erreur est survenue.');
      }
    } catch (error) {
      alert('✗ Erreur de connexion.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F5F1E8] to-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img 
                src="https://static.readdy.ai/image/e2e518312c2a01efc1d4b48128380317/cd96c587d8213689d14023dc1625525b.png" 
                alt="Maïbis Logo" 
                className="w-12 h-12 object-contain rounded-lg"
              />
              <span className="text-2xl font-bold text-[#2C5F2D]">Maïbis</span>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <a href="#accueil" className="text-[#2C5F2D] hover:text-[#4CAF50] transition-colors font-medium">Accueil</a>
              <a href="#branches" className="text-[#2C5F2D] hover:text-[#4CAF50] transition-colors font-medium">Nos branches</a>
              <a href="#services" className="text-[#2C5F2D] hover:text-[#4CAF50] transition-colors font-medium">Services</a>
              <a href="#tarifs" className="text-[#2C5F2D] hover:text-[#4CAF50] transition-colors font-medium">Tarifs</a>
              <a href="#apropos" className="text-[#2C5F2D] hover:text-[#4CAF50] transition-colors font-medium">À propos</a>
              <a href="#contact" className="text-[#2C5F2D] hover:text-[#4CAF50] transition-colors font-medium">Contact</a>
            </div>

            <a href="#contact" className="hidden md:block bg-[#4CAF50] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2C5F2D] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Demander un devis
            </a>

            <button className="md:hidden text-[#2C5F2D] w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="accueil" className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="inline-block bg-[#A5D6A7]/30 border-2 border-[#4CAF50] px-4 py-2 rounded-full">
                <span className="text-[#2C5F2D] font-semibold text-sm">Entreprise Multiservices Certifiée</span>
              </div>
              
              <h1 className="text-5xl md:text-6xl font-bold text-[#2C5F2D] leading-tight">
                Maïbis
                <br />
                <span className="text-4xl md:text-5xl font-normal">Des solutions professionnelles</span>
                <br />
                <span className="text-4xl md:text-5xl italic font-light">pour un développement durable</span>
              </h1>
              
              <p className="text-xl text-gray-600 leading-relaxed">
                Agriculture, élevage, transport, sécurité et services divers
              </p>
              
              <div className="flex flex-wrap gap-4 pt-4">
                <a href="#branches" className="bg-[#4CAF50] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#2C5F2D] transition-all shadow-lg hover:shadow-xl flex items-center space-x-2 whitespace-nowrap cursor-pointer">
                  <span>Découvrir nos branches</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="#contact" className="bg-transparent border-2 border-[#4CAF50] text-[#4CAF50] px-8 py-4 rounded-full font-semibold hover:bg-[#4CAF50] hover:text-white transition-all whitespace-nowrap cursor-pointer">
                  Obtenir un devis
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="transform rotate-[-3deg] rounded-2xl overflow-hidden shadow-2xl">
                  <img src="https://public.readdy.ai/ai/img_res/6379720744b14220ee5eec3ccdb1ff23.jpg" alt="Agriculture" className="w-full h-64 object-cover object-top" />
                </div>
                <div className="transform rotate-[3deg] rounded-2xl overflow-hidden shadow-2xl mt-8">
                  <img src="https://readdy.ai/api/search-image?query=modern%20transport%20truck%20delivery%20vehicle%20Guinea%20Africa%20road%20logistics%20simple%20clean%20background%20professional%20commercial%20transportation%20cargo%20freight&width=400&height=400&seq=maibis002&orientation=squarish" alt="Transport" className="w-full h-64 object-cover object-top" />
                </div>
                <div className="transform rotate-[2deg] rounded-2xl overflow-hidden shadow-2xl col-span-2">
                  <img src="https://readdy.ai/api/search-image?query=professional%20security%20guard%20uniform%20African%20man%20standing%20confident%20simple%20clean%20background%20safety%20protection%20service%20professional%20attire&width=800&height=300&seq=maibis003&orientation=landscape" alt="Sécurité" className="w-full h-48 object-cover object-top" />
                </div>
              </div>
              <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#4CAF50] opacity-10 rounded-full blur-3xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Présentation */}
      <section id="apropos" className="py-20 px-6 bg-gradient-to-b from-white to-[#F5F1E8]">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-xl p-12 md:p-16 text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-[#4CAF50] to-[#2C5F2D] rounded-2xl flex items-center justify-center">
              <i className="ri-building-line text-white text-3xl"></i>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C5F2D] mb-6">Qui sommes-nous ?</h2>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-12 max-w-3xl mx-auto">
              Maïbis est une entreprise structurée autour de plusieurs branches complémentaires, offrant des services et produits de qualité adaptés aux besoins des particuliers, entreprises et collectivités. Notre approche professionnelle et organisée garantit des prestations fiables et accessibles.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              <div className="flex flex-col items-center">
                <div className="w-28 h-28 bg-[#A5D6A7] rounded-full flex items-center justify-center mb-4">
                  <span className="text-4xl font-bold text-[#2C5F2D]">5</span>
                </div>
                <p className="text-sm font-semibold text-gray-600">Branches d'activités</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-28 h-28 bg-[#A5D6A7] rounded-full flex items-center justify-center mb-4">
                  <span className="text-4xl font-bold text-[#2C5F2D]">100%</span>
                </div>
                <p className="text-sm font-semibold text-gray-600">Qualité garantie</p>
              </div>
              <div className="flex flex-col items-center">
                <div className="w-28 h-28 bg-[#A5D6A7] rounded-full flex items-center justify-center mb-4">
                  <span className="text-4xl font-bold text-[#2C5F2D]">24/7</span>
                </div>
                <p className="text-sm font-semibold text-gray-600">Service disponible</p>
              </div>
            </div>
            
            <div className="inline-block bg-[#FFC107]/20 border-2 border-[#FFC107] px-6 py-3 rounded-full">
              <span className="text-[#2C5F2D] font-bold">Tarifs de 3 000 à 8 000 GNF selon prestation</span>
            </div>
          </div>
        </div>
      </section>

      {/* Branches d'activités */}
      <section id="branches" className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C5F2D] mb-4">Nos branches d'activités</h2>
            <p className="text-xl text-gray-600">Des solutions complètes pour tous vos besoins</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Agriculture */}
            <div className="bg-white rounded-2xl border-2 border-[#4CAF50] p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-[#4CAF50]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-plant-line text-[#4CAF50] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Agriculture</h3>
              <p className="text-gray-600 mb-6">Production et commercialisation de produits agricoles de qualité</p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#4CAF50] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de maïs</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#4CAF50] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de riz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#4CAF50] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente d'arachide</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#4CAF50] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de sésame</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#4CAF50] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de soja</span>
                </li>
              </ul>
              <div className="bg-[#4CAF50]/10 rounded-lg p-4 flex items-center justify-between">
                <span className="text-sm text-gray-600">Tarification</span>
                <span className="font-bold text-[#2C5F2D]">Sur devis</span>
              </div>
            </div>

            {/* Aviculture */}
            <div className="bg-white rounded-2xl border-2 border-[#FFC107] p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-[#FFC107]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-contrast-drop-line text-[#FFC107] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Aviculture</h3>
              <p className="text-gray-600 mb-6">Produits frais et transformés de qualité supérieure</p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FFC107] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de poussins</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FFC107] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de poulets (frais ou congelés)</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FFC107] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de viande volaillère</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FFC107] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente d'œufs en gros</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FFC107] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Vente de fientes</span>
                </li>
              </ul>
              <div className="bg-[#FFC107]/10 rounded-lg p-4 flex items-center justify-between">
                <span className="text-sm text-gray-600">Tarification</span>
                <span className="font-bold text-[#2C5F2D]">Sur devis</span>
              </div>
            </div>

            {/* Transport */}
            <div className="bg-white rounded-2xl border-2 border-[#2196F3] p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-[#2196F3]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-truck-line text-[#2196F3] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Transport routier</h3>
              <p className="text-gray-600 mb-6">Prestations de transport et logistique professionnelle</p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#2196F3] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Conducteurs de poids lourds</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#2196F3] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Chauffeurs de bus</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#2196F3] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Livreurs et coursiers</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#2196F3] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Responsables de flotte</span>
                </li>
              </ul>
              <div className="bg-[#2196F3]/10 rounded-lg p-4 flex items-center justify-between">
                <span className="text-sm text-gray-600">Tarification</span>
                <span className="font-bold text-[#2C5F2D]">Sur devis</span>
              </div>
            </div>

            {/* Sécurité */}
            <div className="bg-white rounded-2xl border-2 border-[#FF5722] p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-[#FF5722]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-[#FF5722] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Sécurité</h3>
              <p className="text-gray-600 mb-6">Protection des biens et des personnes 24/7</p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FF5722] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Agents de sécurité qualifiés</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FF5722] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Surveillance de sites</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#FF5722] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Gardiennage professionnel</span>
                </li>
              </ul>
              <div className="bg-[#FF5722]/10 rounded-lg p-4 flex items-center justify-between">
                <span className="text-sm text-gray-600">Tarification</span>
                <span className="font-bold text-[#2C5F2D]">Par mois</span>
              </div>
            </div>

            {/* Services Divers */}
            <div className="bg-white rounded-2xl border-2 border-[#9C27B0] p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer">
              <div className="w-16 h-16 bg-[#9C27B0]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-service-line text-[#9C27B0] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Services divers</h3>
              <p className="text-gray-600 mb-6">Solutions polyvalentes pour tous vos besoins</p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#9C27B0] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Fondation et services communautaires</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#9C27B0] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Baby-sitting professionnel</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#9C27B0] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Autres services sur demande</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#9C27B0] rounded-sm mt-2"></div>
                  <span className="text-gray-700">Donation</span>
                </li>
              </ul>
              <div className="bg-[#9C27B0]/10 rounded-lg p-4 flex items-center justify-between">
                <span className="text-sm text-gray-600">Tarification</span>
                <span className="font-bold text-[#2C5F2D]">Sur devis</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Services - NOUVELLE */}
      <section id="services" className="py-20 px-6 bg-gradient-to-b from-[#F5F1E8] to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C5F2D] mb-4">Nos Services</h2>
            <p className="text-xl text-gray-600">Des prestations complètes et professionnelles</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-16 h-16 bg-[#4CAF50]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-shopping-cart-line text-[#4CAF50] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Vente de produits</h3>
              <p className="text-gray-600 mb-4">
                Commercialisation de produits agricoles et avicoles de qualité supérieure pour particuliers et professionnels.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#4CAF50]"></i>
                  <span>Produits frais et contrôlés</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#4CAF50]"></i>
                  <span>Livraison disponible</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#4CAF50]"></i>
                  <span>Prix compétitifs</span>
                </li>
              </ul>
            </div>

            {/* Service 2 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-16 h-16 bg-[#2196F3]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-truck-line text-[#2196F3] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Transport & Logistique</h3>
              <p className="text-gray-600 mb-4">
                Solutions de transport professionnel pour tous vos besoins de déplacement et de livraison.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#2196F3]"></i>
                  <span>Chauffeurs qualifiés</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#2196F3]"></i>
                  <span>Flotte moderne</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#2196F3]"></i>
                  <span>Service ponctuel</span>
                </li>
              </ul>
            </div>

            {/* Service 3 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-16 h-16 bg-[#FF5722]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-[#FF5722] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Sécurité & Gardiennage</h3>
              <p className="text-gray-600 mb-4">
                Protection professionnelle de vos biens et locaux avec des agents formés et expérimentés.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#FF5722]"></i>
                  <span>Surveillance 24/7</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#FF5722]"></i>
                  <span>Agents certifiés</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#FF5722]"></i>
                  <span>Intervention rapide</span>
                </li>
              </ul>
            </div>

            {/* Service 4 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-16 h-16 bg-[#FFC107]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-seedling-line text-[#FFC107] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Conseil agricole</h3>
              <p className="text-gray-600 mb-4">
                Accompagnement et expertise pour optimiser vos productions agricoles et avicoles.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#FFC107]"></i>
                  <span>Expertise technique</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#FFC107]"></i>
                  <span>Suivi personnalisé</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#FFC107]"></i>
                  <span>Formation disponible</span>
                </li>
              </ul>
            </div>

            {/* Service 5 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-16 h-16 bg-[#9C27B0]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-hand-heart-line text-[#9C27B0] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Services à la personne</h3>
              <p className="text-gray-600 mb-4">
                Prestations de baby-sitting et autres services pour faciliter votre quotidien.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#9C27B0]"></i>
                  <span>Personnel qualifié</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#9C27B0]"></i>
                  <span>Flexibilité horaire</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#9C27B0]"></i>
                  <span>Tarifs adaptés</span>
                </li>
              </ul>
            </div>

            {/* Service 6 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-16 h-16 bg-[#00BCD4]/10 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-heart-line text-[#00BCD4] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-4">Actions sociales</h3>
              <p className="text-gray-600 mb-4">
                Fondation et initiatives communautaires pour le développement local et solidaire.
              </p>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#00BCD4]"></i>
                  <span>Projets communautaires</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#00BCD4]"></i>
                  <span>Donations acceptées</span>
                </li>
                <li className="flex items-center space-x-2">
                  <i className="ri-check-line text-[#00BCD4]"></i>
                  <span>Impact local</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-12">
            <a href="#contact" className="inline-flex items-center space-x-2 bg-[#4CAF50] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#2C5F2D] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              <i className="ri-customer-service-line text-xl"></i>
              <span>Demander un service</span>
            </a>
          </div>
        </div>
      </section>

      {/* Tarifs */}
      <section id="tarifs" className="py-20 px-6 bg-gradient-to-b from-white to-[#F5F1E8]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C5F2D] mb-4">Nos Tarifs Transparents</h2>
            <p className="text-xl text-gray-600">Tarification adaptée à vos besoins</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-[#2C5F2D] text-white">
                    <th className="px-8 py-5 text-left text-lg font-semibold">Type de prestation</th>
                    <th className="px-8 py-5 text-left text-lg font-semibold">Mode de tarification</th>
                    <th className="px-8 py-5 text-left text-lg font-semibold">Fourchette</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 hover:bg-[#F5F1E8] transition-colors">
                    <td className="px-8 py-5 text-gray-700 font-medium">Produits agricoles</td>
                    <td className="px-8 py-5 text-gray-600">Sur devis</td>
                    <td className="px-8 py-5">
                      <span className="bg-[#FFC107]/20 text-[#2C5F2D] px-4 py-2 rounded-full font-bold">3 000 – 8 000 GNF</span>
                    </td>
                  </tr>
                  <tr className="bg-[#F5F1E8]/30 border-b border-gray-100 hover:bg-[#F5F1E8] transition-colors">
                    <td className="px-8 py-5 text-gray-700 font-medium">Aviculture</td>
                    <td className="px-8 py-5 text-gray-600">Sur devis</td>
                    <td className="px-8 py-5">
                      <span className="bg-[#FFC107]/20 text-[#2C5F2D] px-4 py-2 rounded-full font-bold">3 000 – 8 000 GNF</span>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-[#F5F1E8] transition-colors">
                    <td className="px-8 py-5 text-gray-700 font-medium">Transport</td>
                    <td className="px-8 py-5 text-gray-600">Sur devis</td>
                    <td className="px-8 py-5">
                      <span className="bg-[#FFC107]/20 text-[#2C5F2D] px-4 py-2 rounded-full font-bold">180 000 – 500 000 GNF</span>
                    </td>
                  </tr>
                  <tr className="bg-[#F5F1E8]/30 border-b border-gray-100 hover:bg-[#F5F1E8] transition-colors">
                    <td className="px-8 py-5 text-gray-700 font-medium">Sécurité</td>
                    <td className="px-8 py-5 text-gray-600">Sur devis</td>
                    <td className="px-8 py-5">
                      <span className="bg-[#FFC107]/20 text-[#2C5F2D] px-4 py-2 rounded-full font-bold">Par mois</span>
                    </td>
                  </tr>
                  <tr className="hover:bg-[#F5F1E8] transition-colors">
                    <td className="px-8 py-5 text-gray-700 font-medium">Services divers</td>
                    <td className="px-8 py-5 text-gray-600">Sur devis</td>
                    <td className="px-8 py-5">
                      <span className="bg-[#FFC107]/20 text-[#2C5F2D] px-4 py-2 rounded-full font-bold">3 000 – 8 000 GNF</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="text-center mt-12">
            <a href="#contact" className="inline-flex items-center space-x-2 bg-[#4CAF50] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#2C5F2D] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              <i className="ri-calculator-line text-xl"></i>
              <span>Demander un devis personnalisé</span>
            </a>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-20 px-6 bg-gradient-to-br from-[#2C5F2D] to-[#4CAF50]">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Informations de contact */}
            <div className="space-y-8">
              <div>
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Contactez-nous</h2>
                <p className="text-[#A5D6A7] text-lg">Nous sommes à votre écoute pour répondre à tous vos besoins</p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 bg-[#A5D6A7] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#2C5F2D] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Téléphone</h3>
                    <a href="tel:+224622146130" className="text-[#A5D6A7] hover:text-white transition-colors">+224 622 14 61 30</a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 bg-[#A5D6A7] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#2C5F2D] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Email</h3>
                    <a href="mailto:barry2481361@gmail.com" className="text-[#A5D6A7] hover:text-white transition-colors">barry2481361@gmail.com</a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-14 h-14 bg-[#A5D6A7] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#2C5F2D] text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Adresse</h3>
                    <p className="text-[#A5D6A7]">JCV6+GWV Conakry, Guinée</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Formulaire */}
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-[#2C5F2D] mb-6">Envoyer une demande de devis</h3>
              <form id="contact-form" data-readdy-form onSubmit={handleContactSubmit} className="space-y-5">
                <div>
                  <input 
                    type="text" 
                    name="nom" 
                    placeholder="Votre nom complet" 
                    required
                    className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-[#4CAF50] outline-none transition-colors bg-transparent"
                  />
                </div>
                <div>
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="Votre email" 
                    required
                    className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-[#4CAF50] outline-none transition-colors bg-transparent"
                  />
                </div>
                <div>
                  <input 
                    type="tel" 
                    name="telephone" 
                    placeholder="Votre téléphone" 
                    required
                    className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-[#4CAF50] outline-none transition-colors bg-transparent"
                  />
                </div>
                <div>
                  <select 
                    name="branche" 
                    required
                    className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-[#4CAF50] outline-none transition-colors bg-transparent cursor-pointer"
                  >
                    <option value="">Sélectionnez une branche</option>
                    <option value="Agriculture">Agriculture</option>
                    <option value="Aviculture">Aviculture</option>
                    <option value="Transport">Transport routier</option>
                    <option value="Sécurité">Sécurité</option>
                    <option value="Services divers">Services divers</option>
                  </select>
                </div>
                <div>
                  <textarea 
                    name="message" 
                    placeholder="Décrivez votre besoin" 
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-3 border-b-2 border-gray-300 focus:border-[#4CAF50] outline-none transition-colors bg-transparent resize-none"
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Maximum 500 caractères</p>
                </div>
                <button 
                  type="submit"
                  className="w-full bg-[#FFC107] text-[#2C5F2D] py-4 rounded-full font-bold hover:bg-[#FFD54F] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  Envoyer ma demande
                </button>
                <div id="form-message" className="hidden text-center p-4 rounded-lg"></div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Google Maps */}
      <section className="h-96">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.8!2d-13.688!3d9.522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwMzEnMTkuMiJOIDEzwrA0MScxNi44Ilc!5e0!3m2!1sfr!2sgn!4v1234567890"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Localisation Maïbis"
        ></iframe>
      </section>

      {/* Footer */}
      <footer className="bg-[#1B3A1C] text-white py-16 px-6 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5 text-[#F5F1E8] text-[200px] font-bold flex items-center justify-center pointer-events-none" style={{ letterSpacing: '40px' }}>
          MAÏBIS
        </div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            {/* Logo et description */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="https://static.readdy.ai/image/e2e518312c2a01efc1d4b48128380317/cd96c587d8213689d14023dc1625525b.png" 
                  alt="Maïbis Logo" 
                  className="w-12 h-12 object-contain rounded-lg"
                />
                <span className="text-2xl font-bold">Maïbis</span>
              </div>
              <p className="text-[#A5D6A7] text-sm leading-relaxed">
                Entreprise multiservices engagée dans le développement économique durable en Guinée.
              </p>
            </div>

            {/* Liens rapides */}
            <div>
              <h4 className="text-lg font-bold mb-4">Liens rapides</h4>
              <ul className="space-y-2">
                <li><a href="#accueil" className="text-[#A5D6A7] hover:text-white hover:underline transition-colors cursor-pointer">Accueil</a></li>
                <li><a href="#apropos" className="text-[#A5D6A7] hover:text-white hover:underline transition-colors cursor-pointer">À propos</a></li>
                <li><a href="#branches" className="text-[#A5D6A7] hover:text-white hover:underline transition-colors cursor-pointer">Nos branches</a></li>
                <li><a href="#tarifs" className="text-[#A5D6A7] hover:text-white hover:underline transition-colors cursor-pointer">Tarifs</a></li>
                <li><a href="#contact" className="text-[#A5D6A7] hover:text-white hover:underline transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>

            {/* Branches */}
            <div>
              <h4 className="text-lg font-bold mb-4">Nos branches</h4>
              <ul className="space-y-2">
                <li className="text-[#A5D6A7] text-sm">Agriculture</li>
                <li className="text-[#A5D6A7] text-sm">Aviculture</li>
                <li className="text-[#A5D6A7] text-sm">Transport routier</li>
                <li className="text-[#A5D6A7] text-sm">Sécurité</li>
                <li className="text-[#A5D6A7] text-sm">Services divers</li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="text-lg font-bold mb-4">Restez informé</h4>
              <p className="text-[#A5D6A7] text-sm mb-4">Recevez nos actualités et offres</p>
              <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="flex">
                <input 
                  type="email" 
                  name="email"
                  placeholder="Votre email" 
                  required
                  className="flex-1 px-4 py-2 bg-white/10 border border-[#A5D6A7]/30 rounded-l-full outline-none focus:border-[#4CAF50] transition-colors text-sm"
                />
                <button 
                  type="submit"
                  className="bg-[#4CAF50] px-4 py-2 rounded-r-full hover:bg-[#2C5F2D] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
            </div>
          </div>

          <div className="border-t border-[#A5D6A7]/20 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
              <p className="text-[#A5D6A7] text-sm">© 2026 Maïbis – Tous droits réservés</p>
              <div className="flex items-center space-x-6">
                <a href="#" className="text-[#A5D6A7] hover:text-white text-sm hover:underline cursor-pointer">Mentions légales</a>
                <a href="#" className="text-[#A5D6A7] hover:text-white text-sm hover:underline cursor-pointer">Politique de confidentialité</a>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[#A5D6A7] hover:text-white text-sm hover:underline cursor-pointer">Powered by Readdy</a>
              </div>
              <div className="flex items-center space-x-4">
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#4CAF50] hover:rotate-12 transition-all cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#4CAF50] hover:rotate-12 transition-all cursor-pointer">
                  <i className="ri-twitter-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#4CAF50] hover:rotate-12 transition-all cursor-pointer">
                  <i className="ri-instagram-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
